



















































































import { Component, Mixins, Prop, Ref, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CreateBuildingData } from '@/modules/backend/Dto/CreateBuildingData';
import { Resource } from '@/modules/backend/Entities/Resource';
import { CreateRateData } from '@/modules/backend/Dto/CreateRateData';
import { Building } from '@/modules/backend/Entities/Building';
import { AddressData } from '@/modules/backend/Dto/AddressData';
import { KladrContentType, KladrSubject } from '@/modules/backend/Entities/KladrSubject';
import { KladrQueryData } from '@/modules/backend/Dto/KladrQueryData';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { resolveModule } from '@/store';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import { Provider } from '@/modules/backend/Entities/Provider';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { Company } from '@/modules/backend/Entities/Company';

const ErrorsModule = namespace('app/errors');
const ResourcesModule = namespace('dashboard/resources');
const AddressModule = namespace('dashboard/address');

let timeout: NodeJS.Timeout;

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class BuildingAddDialog extends Mixins(Mixin) {
  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @Prop()
  private readonly companyId!: number;

  private loading = false;

  private searchAddress: string | null = null;

  private readonly providersModule: ProvidersModule = resolveModule(ProvidersModule);
  private readonly buildingsModule: BuildingsModule = resolveModule(BuildingsModule);
  private readonly ratesModule: RatesModule = resolveModule(RatesModule);
  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);

  private buildingCreateForm: CreateBuildingData = new CreateBuildingData({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    address: {} as KladrSubject | any,
    providerIds: [],
    companyIds: this.companyId
  });

  @AddressModule.Getter('items')
  private readonly addresses!: KladrSubject[];

  @AddressModule.Action('query')
  private readonly queryAddress!: (data: KladrQueryData) => Promise<void>;

  @ResourcesModule.Action('Fetch')
  private FetchResources!: () => Promise<void>;

  @ResourcesModule.Getter('Resources')
  private Resources!: Resource[];

  @ErrorsModule.Mutation('AddError')
  private AddError!: (message: string) => void;

  private get providers(): Provider[] {
    return this.providersModule.providers;
  }

  private get companies(): Company[] {
    return this.companiesModule.Companies;
  }

  private get items(): { text: string; value: KladrSubject }[] {
    if (!Array.isArray(this.addresses)) {
      return [];
    }

    return this.addresses.filter((subject) => subject.isBuilding).map(item => {
      return {
        text: item.displayName,
        value: item
      };
    });
  }

  private clearForm(): void {
    this.observer.reset();

    this.buildingCreateForm = new CreateBuildingData({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      address: {} as KladrSubject | any,
      providerIds: [],
      companyIds: this.companyId
    });

    this.Resources.forEach((resource: Resource) => {
      this.resourceForm[resource.getId()] = 0;
    });
  }

  public async dialogOpenHandler(): Promise<void> {
    this.clearForm();
    await this.FetchResources();
  }

  public async mounted(): Promise<void> {
    await this.providersModule.fetch();
    await this.companiesModule.Fetch();
  }

  @Watch('searchAddress')
  private async onSearchAddressChange(val: string, _oldVal: string): Promise<void> {
    const MIN_LENGTH = 2;
    const DEBOUNCE_TIMEOUT = 1000;

    if (val && val.trim().length > MIN_LENGTH) {
      this.loading = true;
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        await this.queryAddress({
          query: _oldVal,
          withParent: true,
          contentType: KladrContentType.BUILDING,
          oneString: true
        } as KladrQueryData);

        this.loading = false;
      }, DEBOUNCE_TIMEOUT);
    }
  }

  private get resourceForm(): {[resource: number]: number} {
    return this.Resources.reduce((accum: { [resource: number]: number }, current) => {
      accum[current.getId()] = 0;
      return accum;
    }, {} as {[resource: number]: number});
  }

  private async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      if (
        !this.buildingCreateForm.address as unknown instanceof KladrSubject) {
        this.AddError('Not an address.');
        return;
      }

      let idCompany;
      if (typeof this.companyId === 'undefined') {
        idCompany = this.buildingCreateForm.companyIds;
      } else {
        idCompany = this.companyId;
      }

      const payload = new CreateBuildingData({
        companyId: idCompany,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        address: AddressData.fromKladrSubject(this.buildingCreateForm.address as any),
        providerIds: this.buildingCreateForm.providerIds
      });

      const createdBuilding: Building = await this.buildingsModule.Create(payload);
      const MAX_NUMBER = 1000;
      const ratePayload = Object.entries(this.resourceForm)
        .reduce((accum: CreateRateData[], current: [string, number]) => {
          const [resourceId, value] = current;
          const itemPayload = new CreateRateData();
          itemPayload.buildingId = createdBuilding.getId();
          itemPayload.resourceId = Number(resourceId);
          itemPayload.price = Number(value) >= MAX_NUMBER ? MAX_NUMBER - 1 : Number(value);
          return accum.concat(itemPayload);
        }, [] as CreateRateData[]);

      await Promise.all(ratePayload.map(async (rate: CreateRateData) => {
        await this.ratesModule.create(rate);
      }));
    } else {
      this.AddError(this.$i18n.t('common.validation.error_message') as string);
    }
  }
}
